export default __webpack_public_path__ + "static/media/avatar-05.1eca5db4.png";